//TRANSLATIONS OBJECT WITH KEY AS COMMUNITIES
export const lang = {
    en: {
        genderError: 'This field is required',
        firstnameError: 'This field is required',
        consentError: 'You must consent to receive emails',
        emailError: 'You must enter an email',
        country: 'Country',
        day: 'Day',
        emailField: 'Your email address',
        female: 'Miss',
        male: 'Mister',
        month: 'Month',
        name: 'Firstname',
        step: 'Step',
        year: 'Year',
        countries: {
            ASM: 'American Samoa',
            AUT: 'Austria',
            AUS: 'Australia',
            ATG: 'Antigua and Barbuda',
            AIA: 'Anguilla',
            ALB: 'Albania',
            ARM: 'Armenia',
            AGO: 'Angola',
            ATA: 'Antarctica',
            ARG: 'Argentina',
            AND: 'Andorra',
            ARE: 'United Arab Emirates',
            AFG: 'Afghanistan',
            ABW: 'Aruba',
            ALA: 'Aland Island',
            AZE: 'Azerbaijan',
            BIH: 'Bosnia and Herzegovina',
            BRB: 'Barbados',
            BGD: 'Bangladesh',
            BEL: 'Belgium',
            BFA: 'Burkina Faso',
            BGR: 'Bulgaria',
            BHR: 'Bahrain',
            BDI: 'Burundi',
            BEN: 'Benin',
            BLM: 'Saint Barth&eacute;lemy',
            BMU: 'Bermuda',
            BRN: 'Brunei',
            BOL: 'Bolivia',
            BRA: 'Brazil',
            BHS: 'Bahamas',
            BTN: 'Bhutan',
            BVT: 'Bouvet Island',
            BWA: 'Botswana',
            BLR: 'Belarus',
            BLZ: 'Belize',
            CAN: 'Canada',
            CCK: 'Cocos (Keeling) Islands',
            COD: 'Congo - Democratic Republic of',
            CAF: 'Central African Republic',
            COG: 'Congo',
            CHE: 'Switzerland',
            CIV: 'Cote d&#39;Ivoire',
            COK: 'Cook Islands',
            CHL: 'Chile',
            CMR: 'Cameroon',
            CHN: 'China',
            COL: 'Colombia',
            CRI: 'Costa Rica',
            CUB: 'Cuba',
            CPV: 'Cape Verde',
            CXR: 'Christmas Island',
            CYP: 'Cyprus',
            CZE: 'Czech Republic',
            DEU: 'Germany',
            DJI: 'Djibouti',
            DNK: 'Denmark',
            DMA: 'Dominica',
            DOM: 'Dominican Republic',
            DZA: 'Algeria',
            ECU: 'Ecuador',
            EST: 'Estonia',
            EGY: 'Egypt',
            ESH: 'Western Sahara',
            ERI: 'Eritrea',
            ESP: 'Spain',
            ETH: 'Ethiopia',
            FIN: 'Finland',
            FJI: 'Fiji',
            FLK: 'Falkland Islands (Islas Malvinas)',
            FSM: 'Micronesia - Federated States of',
            FRO: 'Faroe Islands',
            FRA: 'France',
            GAB: 'Gabon',
            GBR: 'United Kingdom',
            GRD: 'Grenada',
            GEO: 'Georgia',
            GUF: 'French Guyana',
            GGY: 'Guernsey',
            GHA: 'Ghana',
            GIB: 'Gibraltar',
            GRL: 'Greenland',
            GMB: 'Gambia',
            GIN: 'Guinea',
            GLP: 'Guadeloupe',
            GNQ: 'Equitorial Guinea',
            GRC: 'Greece',
            SGS: 'South Georgia and the South Sandwich Islands',
            GTM: 'Guatemala',
            GUM: 'Guam',
            GNB: 'Guinea-Bissau',
            GUY: 'Guyana',
            HKG: 'Hong Kong',
            HMD: 'Heard Island and McDonald Islands',
            HND: 'Honduras',
            HRV: 'Croatia',
            HTI: 'Haiti',
            HUN: 'Hungary',
            IDN: 'Indonesia',
            IRL: 'Ireland',
            ISR: 'Israel',
            IMN: 'Isle of Man',
            IND: 'India',
            IOT: 'British Indian Ocean Territory',
            IRQ: 'Iraq',
            IRN: 'Iran',
            ISL: 'Iceland',
            ITA: 'Italy',
            JEY: 'Jersey',
            JAM: 'Jamaica',
            JOR: 'Jordan',
            JPN: 'Japan',
            KEN: 'Kenya',
            KGZ: 'Kyrgyzstan',
            KHM: 'Cambodia',
            KIR: 'Kiribati',
            COM: 'Comoros',
            KNA: 'Saint Kitts and Nevis',
            PRK: 'North Korea',
            KOR: 'South Korea',
            KWT: 'Kuwait',
            CYM: 'Cayman Islands',
            KAZ: 'Kazakhstan',
            LAO: 'Laos',
            LBN: 'Lebanon',
            LCA: 'Saint Lucia',
            LIE: 'Liechtenstein',
            LKA: 'Sri Lanka',
            LBR: 'Liberia',
            LSO: 'Lesotho',
            LTU: 'Lithuania',
            LUX: 'Luxembourg',
            LVA: 'Latvia',
            LBY: 'Libya',
            MAR: 'Morocco',
            MCO: 'Monaco',
            MDA: 'Moldova',
            MNE: 'Montenegro',
            MAF: 'Saint Martin',
            MDG: 'Madagascar',
            MHL: 'Marshall Islands',
            MKD: 'Macedonia - The Former Yugoslav Republic of',
            MLI: 'Mali',
            MMR: 'Myanmar',
            MNG: 'Mongolia',
            MAC: 'Macau',
            MNP: 'Northern Mariana Islands',
            MTQ: 'Martinique',
            MRT: 'Mauritania',
            MSR: 'Montserrat',
            MLT: 'Malta',
            MUS: 'Mauritius',
            MDV: 'Maldives',
            MWI: 'Malawi',
            MEX: 'Mexico',
            MYS: 'Malaysia',
            MOZ: 'Mozambique',
            NAM: 'Namibia',
            NCL: 'New Caledonia',
            NER: 'Niger',
            NFK: 'Norfolk Island',
            NGA: 'Nigeria',
            NIC: 'Nicaragua',
            NLD: 'Netherlands',
            NOR: 'Norway',
            NPL: 'Nepal',
            NRU: 'Nauru',
            NIU: 'Niue',
            NZL: 'New Zealand',
            OMN: 'Oman',
            PAN: 'Panama',
            PER: 'Peru',
            PYF: 'French Polynesia',
            PNG: 'Papua New Guinea',
            PHL: 'Philippines',
            PAK: 'Pakistan',
            POL: 'Poland',
            SPM: 'St. Pierre and Miquelon',
            PCN: 'Pitcairn Islands',
            PRI: 'Puerto Rico',
            PSE: 'Palestina',
            PRT: 'Portugal',
            PLW: 'Palau',
            PRY: 'Paraguay',
            QAT: 'Qatar',
            REU: 'Reunion',
            ROU: 'Romania',
            SRB: 'Serbia',
            RUS: 'Russia',
            RWA: 'Rwanda',
            SAU: 'Saudi Arabia',
            SLB: 'Solomon Islands',
            SYC: 'Seychelles',
            SDN: 'Sudan',
            SWE: 'Sweden',
            SGP: 'Singapore',
            SHN: 'St. Helena',
            SVN: 'Slovenia',
            SJM: 'Svalbard',
            SVK: 'Slovakia',
            SLE: 'Sierra Leone',
            SMR: 'San Marino',
            SEN: 'Senegal',
            SOM: 'Somalia',
            SUR: 'Suriname',
            STP: 'Sao Tome and Principe',
            SLV: 'El Salvador',
            SYR: 'Syria',
            SWZ: 'Swaziland',
            TCA: 'Turks and Caicos Islands',
            TCD: 'Chad',
            ATF: 'French Southern and Antarctic Lands',
            TGO: 'Togo',
            THA: 'Thailand',
            TJK: 'Tajikistan',
            TKL: 'Tokelau',
            TKM: 'Turkmenistan',
            TUN: 'Tunisia',
            TON: 'Tonga',
            TUR: 'Turkey',
            TTO: 'Trinidad and Tobago',
            TUV: 'Tuvalu',
            TWN: 'Taiwan',
            TZA: 'Tanzania',
            UKR: 'Ukraine',
            UGA: 'Uganda',
            UMI: 'United States Minor Outlying Islands',
            USA: 'United States',
            URY: 'Uruguay',
            UZB: 'Uzbekistan',
            VAT: 'Holy See (Vatican City)',
            VCT: 'Saint Vincent and the Grenadines',
            VEN: 'Venezuela',
            VGB: 'British Virgin Islands',
            VIR: 'United States Virgin Islands',
            VNM: 'Vietnam',
            VUT: 'Vanuatu',
            WLF: 'Wallis and Futuna',
            WSM: 'Samoa',
            YEM: 'Yemen',
            MYT: 'Mayotte',
            ZAF: 'South Africa',
            ZMB: 'Zambia',
            ZWE: 'Zimbabwe',
        },
    },
    fr: {
        genderError: 'Ce champ est obligatoire',
        firstnameError: 'Ce champ est obligatoire',
        consentError: 'Vous devez consentir à recevoir des e-mails',
        emailError: 'Vous devez saisir un e-mail',
        country: 'Pays',
        day: 'Jour',
        emailField: 'Votre adresse e-mail',
        female: 'Femme',
        male: 'Homme',
        month: 'Mois',
        name: 'Prénom',
        step: 'Etape',
        year: 'Année',
        countries: {
            ASM: 'Samoa Américaines',
            AUT: 'Autriche',
            AUS: 'Australie',
            ATG: 'Antigua-et-Barbuda',
            AIA: 'Anguilla',
            ALB: 'Albanie',
            ARM: 'Arménie',
            AGO: 'Angola',
            ATA: 'Antarctique',
            ARG: 'Argentine',
            AND: 'Andorre',
            ARE: 'Émirats Arabes Unis',
            AFG: 'Afghanistan',
            ABW: 'Aruba',
            ALA: 'Åland',
            AZE: 'Azerbaïdjan',
            BIH: 'Bosnie-Herzégovine',
            BRB: 'Barbade',
            BGD: 'Bangladesh',
            BEL: 'Belgique',
            BFA: 'Burkina Faso',
            BGR: 'Bulgarie',
            BHR: 'Bahreïn',
            BDI: 'Burundi',
            BEN: 'Bénin',
            BLM: 'Saint-Barthélémy',
            BMU: 'Bermudes',
            BRN: 'Brunei',
            BOL: 'Bolivie',
            BRA: 'Brésil',
            BHS: 'Bahamas',
            BTN: 'Bhoutan',
            BVT: 'Île Bouvet',
            BWA: 'Botswana',
            BLR: 'Biélorussie',
            BLZ: 'Belize',
            CAN: 'Canada',
            CCK: 'Îles Cocos',
            COD: 'République Démocratique du Congo',
            CAF: 'République Centrafricaine',
            COG: 'Congo',
            CHE: 'Suisse',
            COK: 'Îles Cook',
            CIV: "Cote d'Ivoire",
            CHL: 'Chili',
            CMR: 'Cameroun',
            CHN: 'Chine',
            COL: 'Colombie',
            CRI: 'Costa Rica',
            CUB: 'Cuba',
            CPV: 'Cap Vert',
            CXR: 'Île Christmas',
            CYP: 'Chypre',
            CZE: 'République Tchèque',
            DEU: 'Allemagne',
            DJI: 'Djibouti',
            DNK: 'Danemark',
            DMA: 'Dominique',
            DOM: 'République Dominicaine',
            DZA: 'Algérie',
            ECU: 'Équateur',
            EST: 'Estonie',
            EGY: 'Égypte',
            ESH: 'Sahara Occidental',
            ERI: 'Érythrée',
            ESP: 'Espagne',
            ETH: 'Éthiopie',
            FIN: 'Finlande',
            FJI: 'Fidji',
            FLK: 'Îles Malouines',
            FSM: 'Micronésie',
            FRO: 'Îles Féroé',
            FRA: 'France',
            GAB: 'Gabon',
            GBR: 'Royaume-Uni',
            GRD: 'Grenade',
            GEO: 'Géorgie',
            GUF: 'Guyane Française',
            GGY: 'Guernesey',
            GHA: 'Ghana',
            GIB: 'Gibraltar',
            GRL: 'Groenland',
            GMB: 'Gambie',
            GIN: 'Guinée',
            GLP: 'Guadeloupe',
            GNQ: 'Guinée Équatoriale',
            GRC: 'Grèce',
            SGS: 'Géorgie du Sud-et-les Îles Sandwich du Sud',
            GTM: 'Guatemala',
            GUM: 'Guam',
            GNB: 'Guinée-Bissau',
            GUY: 'Guyana',
            HKG: 'Hong Kong',
            HMD: 'Îles Heard-et-MacDonald',
            HND: 'Honduras',
            HRV: 'Croatie',
            HTI: 'Haïti',
            HUN: 'Hongrie',
            IDN: 'Indonésie',
            IRL: 'Irlande',
            ISR: 'Israël',
            IMN: 'Île de Man',
            IND: 'Inde',
            IOT: "Territoire Britannique de l'Océan Indien",
            IRQ: 'Irak',
            IRN: 'Iran',
            ISL: 'Islande',
            ITA: 'Italie',
            JEY: 'Jersey',
            JAM: 'Jamaïque',
            JOR: 'Jordanie',
            JPN: 'Japon',
            KEN: 'Kenya',
            KGZ: 'Kirghizistan',
            KHM: 'Cambodge',
            KIR: 'Kiribati',
            COM: 'Comores',
            KNA: 'Saint-Kitts-et-Nevis',
            PRK: 'Corée du Nord',
            KOR: 'Corée du Sud',
            KWT: 'Koweït',
            CYM: 'Îles Caïmans',
            KAZ: 'Kazakhstan',
            LAO: 'République démocratique populaire du Laos',
            LBN: 'Liban',
            LCA: 'Sainte-Lucie',
            LIE: 'Liechtenstein',
            LKA: 'Sri Lanka',
            LBR: 'Liberia',
            LSO: 'Lesotho',
            LTU: 'Lituanie',
            LUX: 'Luxembourg',
            LVA: 'Lettonie',
            LBY: 'Libye',
            MAR: 'Maroc',
            MCO: 'Monaco',
            MDA: 'Moldavie',
            MNE: 'Monténégro',
            MAF: 'Saint-Martin (partie française)',
            MDG: 'Madagascar',
            MHL: 'Îles Marshall',
            MKD: 'Macédoine',
            MLI: 'Mali',
            MMR: 'Birmanie',
            MNG: 'Mongolie',
            MAC: 'Macao',
            MNP: 'Îles Mariannes du Nord',
            MTQ: 'Martinique',
            MRT: 'Mauritanie',
            MSR: 'Montserrat',
            MLT: 'Malte',
            MUS: 'Île Maurice',
            MDV: 'Maldives',
            MWI: 'Malawi',
            MEX: 'Mexique',
            MYS: 'Malaisie',
            MOZ: 'Mozambique',
            NAM: 'Namibie',
            NCL: 'Nouvelle-Calédonie',
            NER: 'Niger',
            NFK: 'Île Norfolk',
            NGA: 'Nigeria',
            NIC: 'Nicaragua',
            NLD: 'Pays-Bas',
            NOR: 'Norvège',
            NPL: 'Népal',
            NRU: 'Nauru',
            NIU: 'Niue',
            NZL: 'Nouvelle-Zélande',
            OMN: 'Oman',
            PAN: 'Panama',
            PER: 'Pérou',
            PYF: 'Polynésie Française',
            PNG: 'Papouasie-Nouvelle-Guinée',
            PHL: 'Philippines',
            PAK: 'Pakistan',
            POL: 'Pologne',
            SPM: 'Saint-Pierre-et-Miquelon',
            PCN: 'Îles Pitcairn',
            PRI: 'Porto Rico',
            PSE: 'Palestine',
            PRT: 'Portugal',
            PLW: 'Palaos',
            PRY: 'Paraguay',
            QAT: 'Qatar',
            REU: 'Réunion',
            ROU: 'Roumanie',
            SRB: 'Serbie',
            RUS: 'Russie',
            RWA: 'Rwanda',
            SAU: 'Arabie Saoudite',
            SLB: 'Îles Salomon',
            SYC: 'Seychelles',
            SDN: 'Soudan',
            SWE: 'Suède',
            SGP: 'Singapour',
            SHN: 'Saint-Hélène, Ascension et Tristan da Cunha',
            SVN: 'Slovénie',
            SJM: 'Svalbard et Jan Mayen',
            SVK: 'Slovaquie',
            SLE: 'Sierra Leone',
            SMR: 'Saint-Marin',
            SEN: 'Sénégal',
            SOM: 'Somalie',
            SUR: 'Suriname',
            STP: 'Sao Tomé-et-Principe',
            SLV: 'Salvador',
            SYR: 'Syrie',
            SWZ: 'Swaziland',
            TCA: 'Îles Turques-et-Caïques',
            TCD: 'Tchad',
            ATF: 'Terres Australes et Antarctiques Françaises',
            TGO: 'Togo',
            THA: 'Thaïlande',
            TJK: 'Tadjikistan',
            TKL: 'Tokelau',
            TKM: 'Turkménistan',
            TUN: 'Tunisie',
            TON: 'Tonga',
            TUR: 'Turquie',
            TTO: 'Trinité-et-Tobago',
            TUV: 'Tuvalu',
            TWN: 'Taïwan',
            TZA: 'Tanzanie',
            UKR: 'Ukraine',
            UGA: 'Ouganda',
            UMI: 'Îles mineures éloignées des États-Unis',
            USA: 'États-Unis',
            URY: 'Uruguay',
            UZB: 'Ouzbékistan',
            VAT: 'Vatican',
            VCT: 'Saint-Vincent-et-les-Grenadines',
            VEN: 'Venezuela',
            VGB: 'Îles Vierges Britanniques',
            VIR: 'Îles Vierges, U.S.',
            VNM: 'Viêt Nam',
            VUT: 'Vanuatu',
            WLF: 'Wallis-et-Futuna',
            WSM: 'Samoa',
            YEM: 'Yémen',
            MYT: 'Mayotte',
            ZAF: 'Afrique du Sud',
            ZMB: 'Zambie',
            ZWE: 'Zimbabwe',
        },
    },
    de: {
        emailError: 'Sie müssen eine E-Mail eingeben',
        firstnameError: 'Dieses Feld ist erforderlich',
        genderError: 'Dieses Feld ist erforderlich',
        ConsentError: 'Sie müssen dem Erhalt von E-Mails zustimmen',
        country: 'Land',
        day: 'Tag',
        emailField: 'Ihre E-Mail Adresse',
        female: 'Frau',
        male: 'Herr',
        month: 'Monat',
        name: 'Vorname',
        step: 'Schritt',
        year: 'Jahr',
        countries: {
            ASM: 'Amerikanisch-Samoa',
            AUT: 'Österreich',
            AUS: 'Australien',
            ATG: 'Antigua und Barbuda',
            AIA: 'Anguilla',
            ALB: 'Albanien',
            ARM: 'Armenien',
            AGO: 'Angola',
            ATA: 'Antarktis',
            ARG: 'Argentinien',
            AND: 'Andorra',
            ARE: 'Vereinigte Arabische Emirate',
            AFG: 'Afghanistan',
            ABW: 'Aruba',
            ALA: 'Åland-Inseln',
            AZE: 'Aserbaidschan',
            BIH: 'Bosnien-Herzegowina',
            BRB: 'Barbados',
            BGD: 'Bangladesch',
            BEL: 'Belgien',
            BFA: 'Burkina Faso',
            BGR: 'Bulgarien',
            BHR: 'Bahrein',
            BDI: 'Burundi',
            BEN: 'Benim',
            BLM: 'Saint Barthélemy',
            BMU: 'Bermudas',
            BRN: 'Brunei',
            BOL: 'Bolivien',
            BRA: 'Brasilien',
            BHS: 'Bahamas',
            BTN: 'Bhutan',
            BVT: 'Bouvetinsel',
            BWA: 'Botswana',
            BLR: 'Weißrussland',
            BLZ: 'Belize',
            CAN: 'Kanada',
            CCK: 'Kokosinseln',
            COD: 'Demokratische Republik Kongo',
            CAF: 'Zentralafrikanische Republik',
            COG: 'Kongo',
            CIV: 'Elfenbeinküste',
            CHE: 'Schweiz',
            COK: 'Cook-Inseln',
            CHL: 'Chile',
            CMR: 'Kamerun',
            CHN: 'China',
            COL: 'Kolumbien',
            CRI: 'Costa Rica',
            CUB: 'Kuba',
            CPV: 'Kapverden',
            CXR: 'Osterinseln',
            CYP: 'Zypern',
            CZE: 'Tschechien',
            DEU: 'Deutschland',
            DJI: 'Dschibuti',
            DNK: 'Dänemark',
            DMA: 'Dominica',
            DOM: 'Dominikanische Republik',
            DZA: 'Algerien',
            ECU: 'Ecuador',
            EST: 'Estland',
            EGY: 'Ägypten',
            ESH: 'Westsahara',
            ERI: 'Eritrea',
            ESP: 'Spanien',
            ETH: 'Äthiopien',
            FIN: 'Finnland',
            FJI: 'Fidschi',
            FLK: 'Falklandinseln',
            FSM: 'Mikronesien',
            FRO: 'Färöer-Inseln',
            FRA: 'Frankreich',
            GAB: 'Gabun',
            GBR: 'Vereinigtes Königreich',
            GRD: 'Grenada',
            GEO: 'Georgien',
            GUF: 'Französisch Guyana',
            GGY: 'Guernsey',
            GHA: 'Ghana',
            GIB: 'Gibraltar',
            GRL: 'Grönland',
            GMB: 'Gambia',
            GIN: 'Guinea',
            GLP: 'Guadalupe',
            GNQ: 'Äquatorialguinea',
            GRC: 'Griechenland',
            SGS: 'Südgeorgien und die Südlichen Sandwichinseln ',
            GTM: 'Guatemala',
            GUM: 'Guam',
            GNB: 'Guinea Bissau',
            GUY: 'Guyana',
            HKG: 'Hong Kong',
            HMD: 'Heard und McDonaldinseln',
            HND: 'Honduras',
            HRV: 'Kroatien',
            HTI: 'Haiti',
            HUN: 'Ungarn',
            IDN: 'Indonesien',
            IRL: 'Irland',
            ISR: 'Israel',
            IMN: 'Isle of Man',
            IND: 'Indien',
            IOT: 'Britisches Territorium im Indischen Ozean',
            IRQ: 'Irak',
            IRN: 'Iran',
            ISL: 'Island',
            ITA: 'Italien',
            JEY: 'Jersey',
            JAM: 'Jamaika',
            JOR: 'Jordanien',
            JPN: 'Japan',
            KEN: 'Kenia',
            KGZ: 'Kirgistan',
            KHM: 'Kambodscha',
            KIR: 'Kiribati',
            COM: 'Komoren',
            KNA: 'St. Kitts und Nevis',
            PRK: 'Demokratische Volksrepublik Korea',
            KOR: 'Südkorea',
            KWT: 'Kuwait',
            CYM: 'Kaimaninseln',
            KAZ: 'Kasachstan',
            LAO: 'Demokratische Republik Laos',
            LBN: 'Libanon',
            LCA: 'St. Lucia',
            LIE: 'Liechtenstein',
            LKA: 'Sri Lanka',
            LBR: 'Liberia',
            LSO: 'Lesotho',
            LTU: 'Litauen',
            LUX: 'Luxemburg',
            LVA: 'Lettland',
            LBY: 'Libyen',
            MAR: 'Marroko',
            MCO: 'Monaco',
            MDA: 'Republik Moldau',
            MNE: 'Montenegro',
            MAF: 'St. Martin',
            MDG: 'Madagaskar',
            MHL: 'Marshallinseln',
            MKD: 'Mazedonien',
            MLI: 'Mali',
            MMR: 'Myanmar',
            MNG: 'Mongolei',
            MAC: 'Macau',
            MNP: 'Nördliche Marianen',
            MTQ: 'Martinique',
            MRT: 'Mauretanien',
            MSR: 'Montserrate',
            MLT: 'Malta',
            MUS: 'Mauritius',
            MDV: 'Malediven',
            MWI: 'Malawi',
            MEX: 'Mexiko',
            MYS: 'Malaysia',
            MOZ: 'Mosambik',
            NAM: 'Namibia',
            NCL: 'Neukaledonien',
            NER: 'Niger',
            NFK: 'Norfolkinseln',
            NGA: 'Nigeria',
            NIC: 'Nicaragua',
            NLD: 'Niederlande',
            NOR: 'Norwegen',
            NPL: 'Nepal',
            NRU: 'Nauru',
            NIU: 'Niuas',
            NZL: 'Neuseeland',
            OMN: 'Oman',
            PAN: 'Panama',
            PER: 'Peru',
            PYF: 'Französisch Polynesien',
            PNG: 'Papua Neuguinea',
            PHL: 'Philippinen',
            PAK: 'Pakistan',
            POL: 'Polen',
            SPM: 'Saint-Pierre und Miquelon',
            PCN: 'Pitcairninseln',
            PRI: 'Puerto Rico',
            PSE: 'Palästina',
            PRT: 'Portugal',
            PLW: 'Palau',
            PRY: 'Paraguay',
            QAT: 'Katar',
            REU: 'La Réunion',
            ROU: 'Rumänien',
            SRB: 'Serbien',
            RUS: 'Russische Föderation',
            RWA: 'Ruanda',
            SAU: 'Saudi Arabien',
            SLB: 'Salomonen',
            SYC: 'Seychellen',
            SDN: 'Sudan',
            SWE: 'Schweden',
            SGP: 'Singapur',
            SHN: 'St. Helena, Ascension und Tristan da Cunha ',
            SVN: 'Slowenien',
            SJM: 'Svalbard und Jan Mayen',
            SVK: 'Slowakei',
            SLE: 'Sierra Leone',
            SMR: 'Republik San Marino',
            SEN: 'Senegal',
            SOM: 'Somalia',
            SUR: 'Surinam',
            STP: 'São Tomé und Príncipe',
            SLV: 'El Salvador',
            SYR: 'Syrien',
            SWZ: 'Swasiland',
            TCA: 'Turks- und Caicosinseln ',
            TCD: 'Tschad',
            ATF: 'Französische Süd- und Antarktisgebiete',
            TGO: 'Togo',
            THA: 'Thailand',
            TJK: 'Tadschikistan',
            TKL: 'Tokelau',
            TKM: 'Turkmenistan',
            TUN: 'Tunesien',
            TON: 'Tonga',
            TUR: 'Türkei',
            TTO: 'Trinidad und Tobago',
            TUV: 'Tuvalu',
            TWN: 'Taiwan',
            TZA: 'Tansania',
            UKR: 'Ukraine',
            UGA: 'Uganda',
            UMI: 'United States Minor Outlying Islands',
            USA: 'Vereinigte Staaten',
            URY: 'Uruguay',
            UZB: 'Usbekistan',
            VAT: 'Vatikan',
            VCT: 'St. Vincent und die Grenadinen',
            VEN: 'Venezuela',
            VGB: 'Britische Jungferninseln',
            VIR: 'Amerikanische Jungferninseln',
            VNM: 'Vietnam',
            VUT: 'Vanuatu',
            WLF: 'Wallis und Futuna',
            WSM: 'Samoa',
            YEM: 'Jemen',
            MYT: 'Mayotte',
            ZAF: 'Südafrika',
            ZMB: 'Sambia',
            ZWE: 'Simbabwe',
        },
    },
    es: {
        emailError: 'Debes ingresar un correo electrónico',
        genderError: 'Este campo es obligatorio',
        firstnameError: 'Este campo es obligatorio',
        consentError: 'Debe dar su consentimiento para recibir correos electrónicos',
        country: 'País',
        day: 'Día',
        emailField: 'Su dirección de correo electrónico',
        female: 'Señora',
        male: 'Señor',
        month: 'Mes',
        name: 'Nombre',
        step: 'Etapa',
        year: 'Año',
        countries: {
            ASM: 'Samoa Americana',
            AUT: 'Austria',
            AUS: 'Australia',
            ATG: 'Antigua y Barbuda',
            AIA: 'Anguila',
            ALB: 'Albania',
            ARM: 'Armenia',
            AGO: 'Angola',
            ATA: 'Antártida',
            ARG: 'Argentina',
            AND: 'Andorra',
            ARE: 'Emiratos Árabes Unidos',
            AFG: 'Afganistán',
            ABW: 'Aruba',
            ALA: 'Islas Åland',
            AZE: 'Azerbaiyán',
            BIH: 'Bosnia-Herzegovina',
            BRB: 'Barbados',
            BGD: 'Bangladesh',
            BEL: 'Bélgica',
            BFA: 'Burkina Faso',
            BGR: 'Bulgaria',
            BHR: 'Baréin',
            BDI: 'Burundi',
            BEN: 'Benín',
            BLM: 'San Bartolomé',
            BMU: 'Bermudas',
            BRN: 'Brunei Darussalam',
            BOL: 'Bolivia',
            BRA: 'Brasil',
            BHS: 'Bahamas',
            BTN: 'Bután',
            BVT: 'Isla Bouvet',
            BWA: 'Botsuana',
            BLR: 'Bielorrusia',
            BLZ: 'Belice',
            CAN: 'Canadá',
            CCK: 'Islas Cocos',
            COD: 'República Democrática del Congo',
            CAF: 'República Centroafricana',
            CIV: 'Costa de Marfil',
            COG: 'Congo',
            CHE: 'Suiza',
            COK: 'Islas Cook',
            CHL: 'Chile',
            CMR: 'Camerún',
            CHN: 'China',
            COL: 'Colombia',
            CRI: 'Costa Rica',
            CUB: 'Cuba',
            CPV: 'Cabo Verde',
            CXR: 'Isla de Navidad',
            CYP: 'Chipre',
            CZE: 'República Checa',
            DEU: 'Alemania',
            DJI: 'Yibuti',
            DNK: 'Dinamarca',
            DMA: 'Dominica',
            DOM: 'República Dominicana',
            DZA: 'Argelia',
            ECU: 'Ecuador',
            EST: 'Estonia',
            EGY: 'Egipto',
            ESH: 'Sáhara Occidental',
            ERI: 'Eritrea',
            ESP: 'España',
            ETH: 'Etiopía',
            FIN: 'Finlandia',
            FJI: 'Fiyi',
            FLK: 'Islas Malvinas',
            FSM: 'Micronesia, Estados Federados de',
            FRO: 'Islas Feroe',
            FRA: 'Francia',
            GAB: 'Gabón',
            GBR: 'Reino Unido',
            GRD: 'Granada',
            GEO: 'Georgia',
            GUF: 'Guayana Francesa',
            GGY: 'Guernesey',
            GHA: 'Ghana',
            GIB: 'Gibraltar',
            GRL: 'Groenlandia',
            GMB: 'Gambia',
            GIN: 'Guinea',
            GLP: 'Guadalupe',
            GNQ: 'Guinea Ecuatorial',
            GRC: 'Grecia',
            SGS: 'Islas Georgias del Sur y Sandwich del Sur',
            GTM: 'Guatemala',
            GUM: 'Guam',
            GNB: 'Guinea Bissau',
            GUY: 'Guyana',
            HKG: 'Hong Kong',
            HMD: 'Islas Heard y McDonald',
            HND: 'Honduras',
            HRV: 'Croacia',
            HTI: 'Haití',
            HUN: 'Hungría',
            IDN: 'Indonesia',
            IRL: 'Irlanda',
            ISR: 'Israel',
            IMN: 'Isla de Man',
            IND: 'India',
            IOT: 'Territorio Británico del Océano Índico',
            IRQ: 'Iraq',
            IRN: 'Irán',
            ISL: 'Islandia',
            ITA: 'Italia',
            JEY: 'Jersey',
            JAM: 'Jamaica',
            JOR: 'Jordania',
            JPN: 'Japón',
            KEN: 'Kenia',
            KGZ: 'Kirguistán',
            KHM: 'Camboya',
            KIR: 'Kiribati',
            COM: 'Comoras',
            KNA: 'San Cristóbal y Nieves',
            PRK: 'República Popular Democrática de Corea',
            KOR: 'Corea del Sur',
            KWT: 'Kuwait',
            CYM: 'Islas Caimán',
            KAZ: 'Kazajstán',
            LAO: 'República Democrática Popular Lao',
            LBN: 'Líbano',
            LCA: 'Santa Lucía',
            LIE: 'Liechtenstein',
            LKA: 'Sri Lanka',
            LBR: 'Liberia',
            LSO: 'Lesoto',
            LTU: 'Lituania',
            LUX: 'Luxemburgo',
            LVA: 'Letonia',
            LBY: 'Libia',
            MAR: 'Marruecos',
            MCO: 'Mónaco',
            MDA: 'Moldavia',
            MNE: 'Montenegro',
            MAF: 'San Martín (Francia)',
            MDG: 'Madagascar',
            MHL: 'Islas Marshall',
            MKD: 'Macedonia',
            MLI: 'Malí',
            MMR: 'Birmania',
            MNG: 'Mongolia',
            MAC: 'Macao',
            MNP: 'Marianas del Norte',
            MTQ: 'Martinica',
            MRT: 'Mauritania',
            MSR: 'Montserrat',
            MLT: 'Malta',
            MUS: 'Mauricio',
            MDV: 'Maldivas',
            MWI: 'Malawi',
            MEX: 'México',
            MYS: 'Malasia',
            MOZ: 'Mozambique',
            NAM: 'Namibia',
            NCL: 'Nueva Caledonia',
            NER: 'Níger',
            NFK: 'Isla Norfolk',
            NGA: 'Nigeria',
            NIC: 'Nicaragua',
            NLD: 'Países Bajos',
            NOR: 'Noruega',
            NPL: 'Nepal',
            NRU: 'Nauru',
            NIU: 'Niue',
            NZL: 'Nueva Zelanda',
            OMN: 'Omán',
            PAN: 'Panamá',
            PER: 'Perú',
            PYF: 'Polinesia Francesa',
            PNG: 'Papúa-Nueva Guinea',
            PHL: 'Filipinas',
            PAK: 'Pakistán',
            POL: 'Polonia',
            SPM: 'San Pedro y Miquelón',
            PCN: 'Islas Pitcairn',
            PRI: 'Puerto Rico',
            PSE: 'Palestina',
            PRT: 'Portugal',
            PLW: 'Palaos',
            PRY: 'Paraguay',
            QAT: 'Qatar',
            REU: 'Reunión',
            ROU: 'Rumanía',
            SRB: 'Serbia',
            RUS: 'Federación Rusa',
            RWA: 'Ruanda',
            SAU: 'Arabia Saudita',
            SLB: 'Islas Salomón',
            SYC: 'Seychelles',
            SDN: 'Sudán',
            SWE: 'Suecia',
            SGP: 'Singapur',
            SHN: 'Santa Elena, Ascensión y Tristán de Acuña',
            SVN: 'Eslovenia',
            SJM: 'Svalbard y Jan Mayen',
            SVK: 'Eslovaquia',
            SLE: 'Sierra Leona',
            SMR: 'San Marino',
            SEN: 'Senegal',
            SOM: 'Somalia',
            SUR: 'Surinam',
            STP: 'Santo Tomé y Príncipe',
            SLV: 'El Salvador',
            SYR: 'Siria',
            SWZ: 'Suazilandia',
            TCA: 'Islas Turcas y Caicos',
            TCD: 'Chad',
            ATF: 'Tierras Australes y Antárticas Francesas',
            TGO: 'Togo',
            THA: 'Tailandia',
            TJK: 'Tayikistán',
            TKL: 'Tokelau',
            TKM: 'Turkmenistán',
            TUN: 'Túnez',
            TON: 'Tonga',
            TUR: 'Turquía',
            TTO: 'Trinidad y Tobago',
            TUV: 'Tuvalu',
            TWN: 'Taiwán',
            TZA: 'Tanzania',
            UKR: 'Ucrania',
            UGA: 'Uganda',
            UMI: 'Islas Ultramarinas Menores de Estados Unidos',
            USA: 'Estados Unidos',
            URY: 'Uruguay',
            UZB: 'Uzbekistán',
            VAT: 'Vaticano (Ciudad del Vaticano)',
            VCT: 'San Vicente y las Granadinas',
            VEN: 'Venezuela',
            VGB: 'Islas Vírgenes Británicas',
            VIR: 'Islas Vírgenes, Estados Unidos',
            VNM: 'Vietnam',
            VUT: 'Vanuatu',
            WLF: 'Wallis y Futuna',
            WSM: 'Samoa',
            YEM: 'Yemen',
            MYT: 'Mayotte',
            ZAF: 'Sudáfrica',
            ZMB: 'Zambia',
            ZWE: 'Zimbabue',
        },
    },
    pt: {
        genderError: 'Este campo é obrigatório',
        firstnameError: 'Este campo é obrigatório',
        consentError: 'Você deve consentir em receber e-mails',
        emailError: 'Você deve inserir um e-mail',
        country: 'País',
        day: 'Dia',
        emailField: 'O seu endereço de correio electrónico',
        female: 'Senhora',
        male: 'Senhor',
        month: 'Mês',
        name: 'Nome',
        step: 'Etapa',
        year: 'Ano',
        countries: {
            ASM: 'Samoa Americana',
            AUT: 'Áustria',
            AUS: 'Austrália',
            ATG: 'Antígua e Barbuda',
            AIA: 'Anguilla',
            ALB: 'Albânia',
            ARM: 'Armênia',
            AGO: 'Angola',
            ATA: 'Antártica',
            ARG: 'Argentina',
            AND: 'Andorra',
            ARE: 'Emirados Árabes Unidos',
            AFG: 'Afeganistão',
            ABW: 'Aruba',
            ALA: 'Ilhas Alanda',
            AZE: 'Azerbaijão',
            BIH: 'Bósnia e Herzegovina',
            BRB: 'Barbados',
            BGD: 'Bangladesh',
            BEL: 'Bélgica',
            BFA: 'Burquina Faso',
            BGR: 'Bulgária',
            BHR: 'Bahrein',
            BDI: 'Burundi',
            BEN: 'Benim',
            BLM: 'São Bartolomeu',
            BMU: 'Bermudas',
            BRN: 'Brunei',
            BOL: 'Bolívia',
            BRA: 'Brasil',
            BHS: 'Bahamas',
            BTN: 'Butão',
            BVT: 'Ilha Bouvet',
            BWA: 'Botsuana',
            BLR: 'Bielorrússia',
            BLZ: 'Belize',
            CAN: 'Canadá',
            CCK: 'Ilhas dos Cocos',
            CIV: 'Costa do Marfim',
            COD: 'República Democrática do Congo',
            CAF: 'República Centro-Africana',
            COG: 'Congo',
            CHE: 'Suíça',
            COK: 'Ilhas Cook',
            CHL: 'Chile',
            CMR: 'Camarões',
            CHN: 'China',
            COL: 'Colômbia',
            CRI: 'Costa Rica',
            CUB: 'Cuba',
            CPV: 'Cabo Verde',
            CXR: 'Ilhas do Natal',
            CYP: 'Chipre',
            CZE: 'República Checa',
            DEU: 'Alemanha',
            DJI: 'Djibuti',
            DNK: 'Dinamarca',
            DMA: 'Dominica',
            DOM: 'República Dominicana',
            DZA: 'Argélia',
            ECU: 'Equador',
            EST: 'Estônia',
            EGY: 'Egito',
            ESH: 'Saara Ocidental',
            ERI: 'Eritréia',
            ESP: 'Espanha',
            ETH: 'Etiópia',
            FIN: 'Finlândia',
            FJI: 'Fiji',
            FLK: 'Ilhas Malvinas',
            FSM: 'Micronésia',
            FRO: 'Ilhas Faroé',
            FRA: 'França',
            GAB: 'Gabão',
            GBR: 'Reino Unido',
            GRD: 'Granada',
            GEO: 'Geórgia',
            GUF: 'Guiana Francesa',
            GGY: 'Guernsey',
            GHA: 'Gana',
            GIB: 'Gibraltar',
            GRL: 'Groenlândia',
            GMB: 'Gâmbia',
            GIN: 'Guiné',
            GLP: 'Guadalupe',
            GNQ: 'Guiné Equatorial',
            GRC: 'Grécia',
            SGS: 'Ilhas Geórgia do Sul e Sandwich do Sul',
            GTM: 'Guatemala',
            GUM: 'Guam',
            GNB: 'Guiné Bissau',
            GUY: 'Guiana',
            HKG: 'Hong Kong',
            HMD: 'Ilhas Heard e McDonald',
            HND: 'Honduras',
            HRV: 'Croácia',
            HTI: 'Haiti',
            HUN: 'Hungria',
            IDN: 'Indonésia',
            IRL: 'Irlanda',
            ISR: 'Israel',
            IMN: 'Ilha de Man',
            IND: 'Índia',
            IOT: 'Território Britânico do Oceano Índico',
            IRQ: 'Iraque',
            IRN: 'Irã',
            ISL: 'Islândia',
            ITA: 'Itália',
            JEY: 'Jersey',
            JAM: 'Jamaica',
            JOR: 'Jordânia',
            JPN: 'Japão',
            KEN: 'Quênia',
            KGZ: 'Quirguistão',
            KHM: 'Camboja',
            KIR: 'Kiribati',
            COM: 'Comores',
            KNA: 'São Cristóvão e Névis',
            PRK: 'República Popular Democrática da Coreia',
            KOR: 'Coréia do Sul',
            KWT: 'Kuwait',
            CYM: 'Ilhas Caimão',
            KAZ: 'Cazaquistão',
            LAO: 'República Democrática Popular Lau',
            LBN: 'Líbano',
            LCA: 'Santa Lúcia',
            LIE: 'Liechtenstein',
            LKA: 'Sri Lanka',
            LBR: 'Libéria',
            LSO: 'Lesoto',
            LTU: 'Lituânia',
            LUX: 'Luxemburgo',
            LVA: 'Letônia',
            LBY: 'Líbia',
            MAR: 'Marrocos',
            MCO: 'Mônaco',
            MDA: 'Moldávia',
            MNE: 'Montenegro',
            MAF: 'São Martinho',
            MDG: 'Madagascar',
            MHL: 'Ilhas Marsall',
            MKD: 'Macedônia',
            MLI: 'Mali',
            MMR: 'Mianmar',
            MNG: 'Mongólia',
            MAC: 'Macau',
            MNP: 'Ilhas Marianas',
            MTQ: 'Martinica',
            MRT: 'Mauritânia',
            MSR: 'Monserrate',
            MLT: 'Malta',
            MUS: 'Ilhas Maurício',
            MDV: 'Maldivas',
            MWI: 'Malauí',
            MEX: 'México',
            MYS: 'Malásia',
            MOZ: 'Moçambique',
            NAM: 'Namíbia',
            NCL: 'Nova - Caledônia',
            NER: 'Níger',
            NFK: 'Ilha Norfolk',
            NGA: 'Nigéria',
            NIC: 'Nicarágua',
            NLD: 'Holanda',
            NOR: 'Noruega',
            NPL: 'Nepal',
            NRU: 'Nauru',
            NIU: 'Niue',
            NZL: 'Nova - Zelândia',
            OMN: 'Omã',
            PAN: 'Panamá',
            PER: 'Peru',
            PYF: 'Polinésia Francesa',
            PNG: 'Papua Nova Guiné',
            PHL: 'Filipinas',
            PAK: 'Paquistão',
            POL: 'Polônia',
            SPM: 'Saint-Pierre-et-Miquelon',
            PCN: 'Ilhas Pitcairn',
            PRI: 'Porto Rico',
            PSE: 'Palestina',
            PRT: 'Portugal',
            PLW: 'Palau',
            PRY: 'Paraguai',
            QAT: 'Catar',
            REU: 'Reunião',
            ROU: 'Romênia',
            SRB: 'Sérvia',
            RUS: 'Federação Russa',
            RWA: 'Ruanda',
            SAU: 'Arábia Saudita',
            SLB: 'Ilhas Salomão',
            SYC: 'Seicheles',
            SDN: 'Sudão',
            SWE: 'Suécia',
            SGP: 'Cingapura',
            SHN: 'Santa Helena, Ascensão e Tristão da Cunha',
            SVN: 'Eslovênia',
            SJM: 'Svalbard e Jan Mayen',
            SVK: 'Eslováquia',
            SLE: 'Serra Leoa',
            SMR: 'República de San Marino',
            SEN: 'Senegal',
            SOM: 'Somália',
            SUR: 'Suriname',
            STP: 'São Tomé e Príncipe',
            SLV: 'El Salvador',
            SYR: 'Síria',
            SWZ: 'Suazilândia',
            TCA: 'Ilhas Turks e Caicos',
            TCD: 'Chade',
            ATF: 'Terras Austrais e Antárticas Francesas',
            TGO: 'Togo',
            THA: 'Tailândia',
            TJK: 'Tadjiquistão',
            TKL: 'Tokelau',
            TKM: 'Turcomenistão',
            TUN: 'Tunísia',
            TON: 'Tonga',
            TUR: 'Turquia',
            TTO: 'Trinidad e Tobago',
            TUV: 'Tuvalu',
            TWN: 'Taiwan',
            TZA: 'Tanzânia',
            UKR: 'Ucrânia',
            UGA: 'Uganda',
            UMI: 'Ilhas Menores Distantes dos Estados Unidos',
            USA: 'Estados Unidos',
            URY: 'Uruguai',
            UZB: 'Uzbequistão',
            VAT: 'Vaticano',
            VCT: 'São Vicente e Granadinas',
            VEN: 'Venezuela',
            VGB: 'Ilhas Virgens Britânicas',
            VIR: 'Ilhas Virgens, EUA',
            VNM: 'Vietnã',
            VUT: 'Vanuatu',
            WLF: 'Wallis e Futuna',
            WSM: 'Samoa',
            YEM: 'Iêmen',
            MYT: 'Maiote',
            ZAF: 'África do Sul',
            ZMB: 'Zâmbia',
            ZWE: 'Zimbábue',
        },
    },
};
